import React from 'react';
import { graphql } from 'gatsby';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';

const about = (props) => {
  const about = props.data.allMarkdownRemark.edges;
  return (
    <Layout bodyClass="page-about">
      <SEO title="about" />
      <div className="intro">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1>Testimonals</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="container pb-6">
        <div className="row">
          {about.map(edge => (
            <div key={edge.node.frontmatter.path} className="col-12 col-md-6 mb-1">
              <div className="about">
                <div className="about-meta">
                  <h2 className="about-title">{edge.node.frontmatter.title}</h2>
                  <p className="about-name">{edge.node.frontmatter.name}</p>
                  <p className="about-jobtitle">{edge.node.frontmatter.jobtitle}</p>
                </div>
                <div
                  className="about-content"
                  dangerouslySetInnerHTML={{ __html: edge.node.html }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export const query = graphql`
  query aboutQuery {
    allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/about/" }, frontmatter: {draft: {eq: false}} }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      edges {
        node {
          html
          frontmatter {
            title
            path
            name
            jobtitle
          }
        }
      }
    }
  }
`;

export default about;
